import { Box, ColorPicker as ColorPickerBase } from "@wix/design-system";
import React, { useContext, useEffect, useState } from "react";
import { RicosContext } from "./../../../../ricos-context";
import { FloatingLayout } from "../../../modal-layout/floating-layout";
import classes from "./floating-custom-color-picker-scss";
const getColorHex = (color) => typeof color === "string" ? color : color.hex();
const FloatingCustomColorPicker = ({
  title,
  color,
  onCancel,
  onConfirm,
  allowEmpty
}) => {
  const { t, isMobile } = useContext(RicosContext);
  const [colorValue, setColorValue] = useState(color ?? "");
  useEffect(() => {
    setColorValue(color ?? colorValue);
  }, [color]);
  return /* @__PURE__ */ React.createElement(
    FloatingLayout,
    {
      onCloseButtonClick: onCancel,
      sidePanelProps: {
        height: "fit-content",
        width: isMobile ? "100%" : "fit-content"
      },
      header: isMobile ? {
        title
      } : void 0,
      content: {
        children: /* @__PURE__ */ React.createElement(Box, { align: "center" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: isMobile ? classes.colorPicker : void 0,
            tabIndex: 0,
            "aria-label": title
          },
          /* @__PURE__ */ React.createElement(
            ColorPickerBase,
            {
              value: colorValue,
              showConverter: false,
              onChange: (newColor) => {
                setColorValue(getColorHex(newColor));
              },
              onConfirm: (newColor) => {
                onConfirm(getColorHex(newColor));
              },
              onCancel,
              allowEmpty,
              emptyPlaceholder: t("CustomColorPicker_Empty_Placeholder")
            }
          )
        ))
      }
    }
  );
};
export {
  FloatingCustomColorPicker
};
//# sourceMappingURL=floating-custom-color-picker.js.map
